const ApplicationName = 'Incident Management';

const Links = Object.freeze({
    viewTickets: 'incidents/open',
    viewAllTickets: 'incidents/all',
    tileHeaderClick: 'User clicked on title : incidents/all',
    newTicket: 'incidents/new-ticket',
    newIncident: 'New Incident clicked',
    trackIncidentTab: (tabName: string) => `Incident ${tabName} tab`,
    trackIncidentTileClick: (tileName: string) => `Incident dashboard - ${tileName}`,
    clickYesOnExit: (stepId: string) => `${stepId}`,
    getPrevStepTrackingId: (stepId: string) => `${stepId}`,
    ticketPriority: (priorityId: string) => `Priority - ${priorityId}`,
    customerReference: 'CustomerReferenceEdited',
    viewDetailsBtn: (sniNumber: string) => `View details of ${sniNumber}`,
    continueBtn: 'ContinueBtnClicked',
    continueIncidentBanner: 'ContinueIncidentBannerClicked',
    searchByServiceIDTab: 'SearchByServiceIDTabClicked',
    searchByLocationTab: 'SearchByLocationTabClicked',
    getServiceID: (serviceID: string) => `Service ID - ${serviceID}`,
    getSelectedCountry: (country: string) => `Country - ${country}`,
    getSelectedState: (state: string) => `Country - ${state}`,
    getSelectedCity: (city: string) => `City - ${city}`,
    getSelectedStreet: (street: string) => `Street - ${street}`,
    getLocationServiceID: (locationServiceID: string) => `Location Service ID - ${locationServiceID}`,
    nextBtn: 'NextBtnClicked',
    skipBtn: 'SkipBtnClicked',
    loadMoreBtn: (offSet: number) => `Clicked on load more for ${offSet} time(s)`,
    submitServiceIdSelectionBtn: 'submitServiceIdSelectionBtnClicked',
    backToLocationSelectionbtn: 'backToLocationSelectionbtnClicked',
    closeIncidentBtn: 'CloseIncidentBtnClicked',
    getReasonForClosure: (reason: string) => `Reason for closure - ${reason}`,
    closeModalSubmit: 'CloseModalSubmitBtnClicked',
    getMajorIncidentDetails: (majorIncidentName: string) => `Clicked on - ${majorIncidentName}`,
    raiseNewIncidentForMajorIncident: (incNumber: string) => `Raise new incident for major incident - ${incNumber}`,
    createIncidentSubmit: 'SubmitIncidentButtonClicked',
    mdmCreateIncidentSubmit: 'MDMSubmitIncidentButtonClicked',
    attachmentBtn: 'AttachmentBtnClicked',
    commentSubmitBtn: 'CommentSubmitBtnClicked',
    resolutionFormCommentBtn: 'ResolutionFormCommentBtnClicked',
    SinglePageNewIncidentBackBtn: 'SinglePageNewIncidentBackBtnClicked',
    openFilter: 'Filter opened',
    cancelFilter: 'Filter Cancel',
    applyFilter: 'Filter Apply',
    clearAllFilters: 'Filter Clear all',
    searchSubmit: 'Searched incidents',
    clickSelectColumns: 'Select columns opened',
    resetSelectColumns: 'Select columns Reset',
    cancelSelectColumns: 'Select columns Cancel',
    applySelectColumns: 'Select columns Apply',
    selectColumn: (column, checkStatus) => `Select columns ${column} ${checkStatus}`,
    pageChange: (index: number) => `Page number changed ${index}`,
    pageSizeChange: (size: number) => `Page size changed to ${size}`,
    sortIncidents: (field, order) => `${field} ${order} Sorting`,
    navigateToDetailsPage: 'Incidents details page visited',
    escalationLetUsKnowBtn: 'LetUsKnowBtnClicked',
    closeEscalationModalBtn: 'CloseEscalationModalBtnClicked',
    CancelEscalationModalBtn: 'CancelEscalationModalBtnClicked',
    SubmitEscalationModalBtn: 'SubmitEscalationModalBtnClicked',
    getEscalationReason: (escalationReason: string) => `Reason for urgent update - ${escalationReason}`,
    runDiagnosticTest: 'RunDiagnosticTestBtnClicked',
    continueCreateIncident: 'ContinueCreateIncidentLinkBtnClicked',
    retryDiagnosticTest: 'RetryDiagnosticTestBtnClicked',
    fnnTestEnterNewServiceId: 'EnterNewServiceIDLinkBtnClicked',
    toggleFnnDiagnosticTestVisibility: 'ToggleFnnDiagnosticTestVisibilityLinkBtnClicked',
    submitSupportEnquiry: 'SubmitASupportEnquiryLinkBtnClicked',
    viewDiagnosticResults: 'ViewDiagnosticResultsBtnClicked',
    getFormSubmissionErrors: (fieldNames: string) => `Required fields - ${fieldNames}`,
    activityPanelSendBtn: 'ActivityPanelSendBtnClicked',
    stillFacingIssueBtn: 'StillFacingIssueBtnClicked',
    resolveIncidentBtn: 'ResolveIncidentBtnClicked',
    manageAttachmentBtn: 'ManageAttachmentBtnClicked',
    cancelAttachmentDeletionBtn: 'CancelAttachmentDeletionBtnClicked',
    saveAttachmentDeletionBtn: 'SaveAttachmentDeletionBtnClicked',
    deleteAttachmentBtn: 'DeleteAttachmentBtnClicked',
    cancelIncidentClosureBtn: 'CancelIncidentClosureBtnClicked',
    requestAnUpdateBtn: 'RequestAnUpdateBtnClicked',
    lastYearClosedIncidentsLink: 'LastYearClosedIncidentsLinkBtnClicked',
    last45DaysClosedIncidentsLink: 'Last45DaysClosedIncidentsLinkBtnClicked',
    twHubLinkBtn: 'TW Hub link clicked',
    twHubModalCancelBtn: 'TW Hub modal cancel clicked',
    twHubModalContinueBtn: 'TW Hub link continue clicked',
    getBackupPowerStatus: (powerOutageStatus: string) => `Power outage: backup power available? ${powerOutageStatus}`,
    getDynamicRadioSelection: (selectedOption: string) => `RadioButtonClicked ${selectedOption}`,
    stayOnIncidentPage: 'NoStayOnThisPageModalBtnClicked',
    leaveIncidentPage: 'LeaveIncidentPageModalBtnClicked',
    plannedMaintenancePageLink: (ticketId: string) => `TicketId - ${ticketId}`,
    openSNILink: (sniNumber: string) => `Active incident - ${sniNumber}`,
    toggleOpenIncidents: 'ToggleOpenIncidentsResultsBtnClicked',
    parentChildIncidentPageLink: (ticketId: string) => ticketId,
    intPMContinueFormSubmission: (outageType: string) => `ContinueCreateIncidentLinkBtnClicked: ${outageType}`,
    guestDashboardYourIncidents: 'YourIncidentsLinkBtnClicked',
    guestDashboardActiveIncidents: 'ActiveIncidentsLinkBtnClicked',
    guestRaiseIncident: 'RaiseIncidentBtnClicked',
    guestViewIncidentBtn: 'ViewIncidentBtnClicked',
    getViewGuestIncidentPageLink: (incident: string) => `View incident - ${incident}`,
    goToDashboardBreadcrumbLink: 'GoToDashboardBreadcrumbLinkClicked',
    goToTrackPageBreadcrumbLink: 'GoToTrackPageBreadcrumbLinkClicked',
    submittedIncidentLink: 'SubmittedIncidentLinkBtnClicked',
    goToDashboardBtn: 'GoToDashboardButtonClicked',
    tryAgainBtn: 'TryAgainButtonClicked',
    viewAllIncidentsBtn: 'ViewAllIncidentsBtnClicked',
    csvDownloadIncidents: 'CSVDownloadClicked',
    csvDownloadIncidentsSuccess: 'CSVDownloadCompleted',
    csvDownloadIncidentsError: 'CSVDownloadError',
    searchByLocationApiErrorRefreshBtn: 'searchByLocationApiErrorRefreshBtnClicked',
    searchByLocationApiErrorReportErrorBtn: 'searchByLocationApiErrorReportErrorBtnClicked',
    searchByLocationNoDataRefineSearchBtn: 'searchByLocationNoDataRefineSearchBtnClicked',
    keepIncidentOpenModalBtn: 'KeepIncidentOpenBtnClicked',
    keepIncidentOpenModalCancelBtn: 'KeepIncidentOpenModal/CancelBtnClicked',
    keepIncidentOpenModalSubmitBtn: 'KeepIncidentOpenModal/SubmitBtnClicked',
    confirmIncidentResolvedModalBtn: 'ConfirmIncidentResolvedBtnClicked',
    confirmIncidentResolvedModalCancelBtn: 'ConfirmIncidentResolvedModal/CancelBtnClicked',
    confirmIncidentResolvedModalSubmitBtn: 'ConfirmIncidentResolvedModal/SubmitBtnClicked',
    resolveGlobalIncidentApiErrorRefreshBtn: 'ResolveGlobalIncidentApiErrorRefreshBtnClicked',
    resolveGlobalIncidentApiErrorReportErrorBtn: 'ResolveGlobalIncidentApiErrorReportErrorBtnClicked',
    globalLoadMoreBtn: 'LoadMoreBtnClicked',
});

const Components = Object.freeze({
    clickExitComponent: 'Exit/',
    clickBackComponent: 'BackFrom/',
    enterSearchComponent: 'Incidents/',
    incidentDetailsComponent: 'IncidentDetails/',
    globalIncidentDetailsComponent: 'GlobalIncidentDetails/',
    incidentListCustomerRefComponent: 'IncidentList/',
    incidentPreviewStepComponent: 'IncidentPreviewStep/',
    searchByServiceIDTabComponent: 'SearchByServiceIDTab/',
    searchByLocationTabComponent: 'SearchByLocationTab/',
    affectedServiceIDComponent: 'AffectedServiceID/',
    majorIncidentBanner: 'MajorIncident/',
    createIncidentComponent: 'CreateIncident/',
    singlePageNewIncidentComponent: 'SinglePageNewIncident/',
    singlePageSearchByLocationModal: 'SinglePageSearchByLocationModal/',
    globalSearchByLocationModal: 'GlobalSearchByLocationModal/',
    globalIncident: 'GlobalIncident/',
    strategicIncident: 'StrategicIncident/',
    escalateIncident: 'EscalateIncident/',
    intEscalateIncident: 'IntEscalateIncident/',
    fnnDiagnosticTest: 'FNNDiagnosticTest/',
    incidentFormSubmissionErrors: 'IncidentFormSubmissionErrors/',
    incidentResolutionBlock: 'IncidentResolutionBlock/',
    incidentSummaryAttachmentsBlock: 'IncidentSummaryAttachmentsBlock',
    closeIncidentComponent: 'CloseIncident/',
    twHub: 'TWHub',
    dynamicForm: 'DynamicForm/',
    intMerge: 'InternationalPlannedMaintenance/',
    parentChildIncidents: 'ParentChildIncidents/',
    trackingIncidents: 'Tracking-Incidents',
    guestIncidentsDashboard: 'GuestIncident/Dashboard/',
    trackGuestIncidents: 'GuestIncident/Track/',
    viewGuestIncident: 'GuestIncident/View/',
    createGuestIncident: 'GuestIncident/Create/',
    downloadIncidentList: 'DownloadIncident',
    resolveGlobalIncident: 'ResolveGlobalIncident/',
});

export {
    ApplicationName,
    Links,
    Components
};
